module.exports = __webpack_public_path__ + "img/BretteCooke.85ce64bb.jpg";